<template>
	<div class="mt-3">
		<canvas class="canvas" :id="canvasId">
		</canvas>
	</div>
</template>

<script>

import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import Stats from 'three/examples/jsm/libs/stats.module.js';

let stats;

export default {
	name: 'CanvasThree',
	props: {
		args: Object,
		canvasType: String,
		canvasId: String,
		width: Number,
		height: Number,
	},
	watch: {
		args: {
			deep: true, // because args is an object
			handler (newVal, oldVal) {
				this.rendering(this.canvasId, this.canvasType, this.args, this.width, this.height, false);
			}
		}
	},
	mounted() {
		this.rendering(this.canvasId, this.canvasType, this.args, this.width, this.height, true);
  },
	methods: {
		rendering(canvasId, canvasType, args, width, height, animationReset) {

// ---- THREE.JS CODE

let frequency = args.frequency;
let amplitude = args.amplitude;
let phase = args.phase;
let config = canvasType;
let scene, renderer;

console.log(width, height);
console.log(args);

function global(template) {

let camera;
let canvas;
let controls, stats;

let mesh;
let distances = []; // macDistance attribute

let pointLight2, pointLight3, pointLight4;

let sclX = 4;
let sclY = 4;

if (window.innerWidth > 900) {
  sclX = 6;
  sclY = 6;
}

const maxDistance = 15;
const cameraZ = 20;

const dummy = new THREE.Object3D();

let counter, counterCamera, counterLight;

if (template === "movement") {
	counter = 0;
} else if (template === "camera") {
	counter = 30;
	counterCamera = 270;
} else if (template === "light") {
	counter = 30;
	counterLight = 0;
}


function init() {
	scene = new THREE.Scene();
	camera = new THREE.PerspectiveCamera(
	70,
	1,
	1,
	3000
	);

	
	let canvas = document.getElementById(canvasId); 

	// cleaning
	renderer = new THREE.WebGLRenderer({ antialias : false, canvas});
	renderer.setPixelRatio( window.devicePixelRatio );

	onWindowResize();

	let colorBackground;

	// instance: each instance has a different color
	const geometry = new THREE.BoxGeometry(1);
	const material = new THREE.MeshStandardMaterial({
	});
	// mesh
	mesh = new THREE.InstancedMesh(geometry, material, sclX*sclY);

	let colCount = 0;
	let color, hue;

	const col1 = getComputedStyle(document.documentElement)
    .getPropertyValue('--col1');
	const col2 = getComputedStyle(document.documentElement)
    .getPropertyValue('--col2');
	const col3 = getComputedStyle(document.documentElement)
    .getPropertyValue('--col3');

	const palette = [col1, col2, col3];
	console.log(palette);

	for (let i=0; i<sclX; i++) {
		for (let j=0; j<sclY; j++) {
			color = new THREE.Color(`${palette[parseInt(Math.random()*(palette.length))]}`);
			mesh.setColorAt(colCount, color)	
			distances.push(Math.random()*maxDistance*2 - maxDistance);
			colCount ++;
		}
	}

	mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
	scene.add(mesh);

	if (template === "movement") {
		camera.position.set(0,0,cameraZ);
	} else if (template === "camera" ) {
		camera.position.set(cameraZ*2,cameraZ*2,cameraZ*2);
	} else {
		camera.position.set(cameraZ/4,cameraZ/4,cameraZ/4);
	}
	
	const ambientLight = new THREE.AmbientLight(0xffffff, 0.7);
	const pointLight = new THREE.PointLight(0xffffff, 0.1);
	pointLight.position.set(-maxDistance*2,maxDistance*2,maxDistance*2);

	if ( template === "light") {
		pointLight2 = new THREE.PointLight(0xffffff, 0.3);
		pointLight2.position.set(-100,0,0);
		scene.add(pointLight2);
		pointLight3 = new THREE.PointLight(0xffffff, 0.3);
		pointLight3.position.set(100,0,0);
		scene.add(pointLight3);
		pointLight4 = new THREE.PointLight(0xffffff, 0.3);
		pointLight4.position.set(0,100,0);
		scene.add(pointLight4);
	}

	if (template === "light") {
		colorBackground = new THREE.Color("#000");
	}
	else {
		colorBackground = new THREE.Color("#fff")
		scene.add(ambientLight);
		scene.add(pointLight);
	}

	scene.background = colorBackground;

  // STATS
  //stats = new Stats();
  //document.body.appendChild( stats.dom );

}

function animate() {
	requestAnimationFrame(animate);
  // stats.update();

	// matrix and updates
	let ct = 0;
	let ctEdges = 0;

	const t = Date.now() * 0.001;

	if (mesh) {
		for (let i=0; i<sclX; i++) {
			for (let j=0; j<sclY; j++) {
				dummy.position.x = i - sclX/2 + 0.5;
				dummy.position.y = j - sclY/2 + 0.5;
				//dummy.position.z = THREE.MathUtils.mapLinear(Math.sin(THREE.MathUtils.degToRad(time)), -1, 1, -distances[ct], distances[ct]);
				if (template === "movement") {
					dummy.position.z = amplitude*Math.sin((frequency*t) + phase) * distances[ct];
				} else { dummy.position.z = distances[ct] }
				dummy.updateMatrix();
				mesh.setMatrixAt( ct ++, dummy.matrix );
			}
		}
		mesh.instanceMatrix.needsUpdate = true;
	}

	camera.lookAt( scene.position );
	renderer.render(scene, camera);
	//controls.update();
	//stats.update();

	if (template === "camera") {
		camera.position.set(
			Math.abs(Math.sin(frequency*t + phase)*cameraZ*amplitude),
			Math.abs(Math.sin(frequency*t + phase)*cameraZ*amplitude),
			Math.abs(Math.sin(frequency*t + phase)*cameraZ*amplitude)
		);
	}

	if (template === "light") {
		pointLight2.intensity = Math.abs(Math.sin(frequency*t + phase) * amplitude/3);
		pointLight3.intensity = Math.abs(Math.sin(frequency*t + phase) * amplitude/3);
		pointLight4.intensity = Math.abs(Math.sin(frequency*t + phase) * amplitude/3);
	}

}

function onWindowResize() {
	camera.aspect = 1 ;
	camera.updateProjectionMatrix();
	if (window.innerWidth > 1600) {
				width = 500;
				height = 500;
			} else if (window.innerWidth > 1200) {
				width = 350;
				height = 350;
			}
				else if (window.innerWidth > 900) {
				width = 300;
				height = 300;
			} else if (window.innerWidth > 700) {
				width = 200;
				height = 200;
			} else if (window.innerWidth > 430) {
				width = 400;
				height = 400;
			} else {
				width = 250;
				height = 250;
			}
	renderer.setSize(width, height);
}

function onClick() {
	//renderer.setSize(500, 500);
	while(scene.children.length > 0){ 
    scene.remove(scene.children[0]); 
	}
}

window.addEventListener("resize", onWindowResize, false);
document.getElementById("frequency").addEventListener("input", onClick); 
document.getElementById("amplitude").addEventListener("input", onClick);
document.getElementById("phase").addEventListener("input", onClick);

init();
if (!animationReset) {
  // renderer cleaning
  renderer.dispose();
  //renderer.context=undefined;
  renderer.domElement=undefined;
}
animate();


}

global(config);

// ---- END OF THREE.JS CODE


		}
	}
}

</script>

<style scoped>

canvas {
}

.mt-3 {
	margin-top: 30px;
}

.canvas {
	margin: 5px;
	border: 4px solid var(--col0);
}

@media only screen and (max-width: 500px) {
	.canvas {
		margin: 5px 0px;
	}
}

</style>
